export type AuthenticatedExternalLinkResponse = Record<string, string> | string;

export interface ResolveAuthenticatedExternalLinkUrlParams {
  response: AuthenticatedExternalLinkResponse;
  sourceHref: string;
}

export type ResolveAuthenticatedExternalLinkUrl = (
  params: ResolveAuthenticatedExternalLinkUrlParams
) => string | null;

function readResponseValue(
  response: AuthenticatedExternalLinkResponse,
  key: string
): string | null {
  if (typeof response === 'string') {
    return response;
  }

  return response[key] ?? null;
}

/** Appends the API token to the clicked URL as a query param. */
export function appendTokenToSourceHref({
  response,
  sourceHref
}: ResolveAuthenticatedExternalLinkUrlParams): string | null {
  const token = readResponseValue(response, 'token');

  if (!token) {
    return null;
  }

  try {
    const url = new URL(sourceHref);

    url.searchParams.set('token', token);

    return url.toString();
  } catch {
    return null;
  }
}

/**
 * Opens the URL returned by the API (`data` already unwrapped by ApiLiv).
 * Use when the backend returns the final auth/redirect URL.
 */
export function useApiResponseUrl({
  response
}: ResolveAuthenticatedExternalLinkUrlParams): string | null {
  const url = readResponseValue(response, 'url');

  if (!url) {
    return null;
  }

  try {
    return new URL(url).toString();
  } catch {
    return null;
  }
}
